import { useNovel } from '@/context/novel-context';
import type { EntityType, SectionDefinition } from '@/lib/types';
import { useMemo } from 'react';

/**
 * Hook to load user-defined entity settings (sections and fields) from denormalized novel data.
 */
export function useEntitySettings(type: EntityType | string) {
  const { novel, isLoading, error } = useNovel();

  const sections: SectionDefinition[] = useMemo(() => {
    return novel?.settings?.[type] || [];
  }, [novel, type]);

  return {
    sections,
    isLoading,
    error,
  };
}
